import { i18n } from "@lingui/core";
import React from 'react';
import './videos.scss';
import SEO from '../components/seo';
import Pagination from '../components/shared/navigation/pagination/pagination';
import Card from '../components/shared/ui-elements/card/card';
import { getAllLocaleUtils } from '../hooks/i18n-hook';

var VideosPage = function VideosPage(_ref) {
  var data = _ref.data,
      pageContext = _ref.pageContext;
  var videos = data.allYoutubeVideo.edges;

  var _getAllLocaleUtils = getAllLocaleUtils(),
      i18n = _getAllLocaleUtils.i18n,
      locale = _getAllLocaleUtils.locale;

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SEO, {
    title: i18n._(
    /*i18n*/
    i18n._("Contact")),
    lang: locale
  }), /*#__PURE__*/React.createElement("div", {
    className: "videos-page"
  }, /*#__PURE__*/React.createElement("ul", {
    className: "videos-page__video-list"
  }, videos.map(function (_ref2) {
    var v = _ref2.node;
    return /*#__PURE__*/React.createElement("li", {
      key: v.id
    }, /*#__PURE__*/React.createElement(Card, {
      item: v,
      place: "videos-page"
    }));
  })), /*#__PURE__*/React.createElement(Pagination, {
    context: pageContext
  })));
};

export default VideosPage;
var pageQuery = "3626755997";